import React, { forwardRef } from 'react';
import { CustomItem } from '@atlaskit/menu';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteLinkItemProps } from '@atlassian/jira-navigation-types/src/types.tsx';
import { Link } from '@atlassian/react-resource-router';
import { WithUnwrappedInteractiveChildren } from '../interactive-item/index.tsx';

// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
const LinkWithUnwrappedInteractiveChildren = WithUnwrappedInteractiveChildren(Link);

export const RouteLinkItem = forwardRef<HTMLAnchorElement, RouteLinkItemProps>(
	({ rel, target, ...props }, ref) => (
		<CustomItem
			component={
				fg('jfp-a11y-team_interactive-elements-nesting')
					? LinkWithUnwrappedInteractiveChildren
					: Link
			}
			rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : '')}
			target={target}
			prefetch="hover"
			ref={ref}
			{...props}
		/>
	),
);
